<div class="confirmation-disclaimer"><p [innerHTML]="disclaimer"></p></div>
